/**
 * GEN-04-04 (7): the OS remembers whether the left menu is collapsed, per
 * user, until sign-out. Kept in localStorage under the user's id so two people
 * sharing a browser do not inherit each other's choice; cleared on sign-out.
 */
const PREFIX = 'yakson_sidebar_collapsed:';

export function readSidebarCollapsed(userId: string | null | undefined): boolean {
  if (!userId) return false;
  try {
    return localStorage.getItem(PREFIX + userId) === '1';
  } catch {
    return false;
  }
}

export function writeSidebarCollapsed(userId: string | null | undefined, collapsed: boolean): void {
  if (!userId) return;
  try {
    if (collapsed) localStorage.setItem(PREFIX + userId, '1');
    else localStorage.removeItem(PREFIX + userId);
  } catch {
    /* localStorage unavailable */
  }
}

/** Sign-out forgets the choice (GEN-04-04). */
export function clearSidebarCollapsed(): void {
  try {
    const stale: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(PREFIX)) stale.push(key);
    }
    stale.forEach((key) => localStorage.removeItem(key));
  } catch {
    /* localStorage unavailable */
  }
}
